export function maskCapitalized(str: string) {
	return str
		.toLocaleLowerCase()
		.replace(/ *\([^)]*\) */g, "")
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ")
		.trim();
}
